let unauthorizedHandler = null;
let handlingUnauthorized = false;

/** Register a handler invoked when an authenticated API call returns 401. */
export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = typeof handler === 'function' ? handler : null;
}

/**
 * Notify listeners that the session is no longer valid.
 * Dedupes rapid parallel 401s into a single redirect/toast.
 */
export function notifyUnauthorized(
  message = 'Please sign in — your session has expired.',
) {
  if (handlingUnauthorized) return;
  if (!unauthorizedHandler) return;
  handlingUnauthorized = true;
  try {
    unauthorizedHandler(message);
  } finally {
    window.setTimeout(() => {
      handlingUnauthorized = false;
    }, 1500);
  }
}
